import React, { Component } from "react";
import Heading from "../Heading.jsx";
import MyImg from "../../Img/Fahim.jpg";
import Social from "../Pages/Social.jsx";

class AboutSec extends Component {
  render() {
    return (
      <div>
        <div id="about" style={{ background: "#111a28" }}>
          <div className="container">
            <div className="row">
              <div className="col-12 text-center">
                <Heading heading={this.props.heading} />
              </div>
            </div>
            <div className="row mt-5">
              <div className="col-lg-8  about-text">
                <p style={{ lineHeight: "2" }} className="text-white">
                  আমি ফয়সাল আহাম্মেদ চৌধুরী, আপনি আমাকে ফয়সাল বলতে পারেন। একজন
                  ফ্রন্ট এন্ড ওয়েব ডেভেলপার। গত ১ বছর ধরে আমি ওয়েব নিয়ে কাজ
                  করছি। আমি সর্বদা এমন ক্লায়েন্টদের সন্ধান করি যারা আমাকে
                  সৃজনশীলতার সাথে চ্যালেঞ্জ জানায়। সবসময় নতুন কিছু শিখতে
                  ভালবাসি।
                </p>
                <div className="row mt-3">
                  <div className="col-md-6 text-white mt-2">
                    <p>
                      <b>দেশ :</b> বাংলাদেশ
                    </p>
                    <p>
                      <b>ই-মেইল :</b> contact.faysalchowdhury99@gmail.com
                    </p>
                  </div>
                  <div className="col-md-6 mt-0 mt-md-2 text-white">
                    <p>
                      <b>হোয়াটসঅ্যাপ :</b> +৮৮-০১৬১০১৩৭৬৭৫
                    </p>
                    <a style={{ color: "#00cf5d" }} href="javascript:void(0)">
                      <b>সিভি দেখুন</b>
                    </a>
                  </div>
                  <div className="col-12 mt-3 mt-lg-0">
                    <p style={{ color: "#ffffff", display: "inline-block" }}>
                      <b>অনুসরণ করুন :</b>
                    </p>
                    <Social firstChild="fa fa-facebook" />
                  </div>
                </div>
              </div>
              <div className="col-lg-4 text-center mt-5 mt-lg-0">
                <img
                  src={MyImg}
                  alt="faysal"
                  className="img-fluid rounded myimg"
                />
              </div>
            </div>
          </div>
          <div className="space"></div>
        </div>
      </div>
    );
  }
}

export default AboutSec;
